document.addEventListener('DOMContentLoaded', function ()
{

    const navbar = document.getElementById('header');
    const heroSection = document.querySelector('section#hero');

    if (!navbar || !heroSection) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                // Dentro del hero - restaurar fondo original
                navbar.classList.remove('bg-neutral-900');
                navbar.classList.add('bg-transparent');
            } else {
                // Fuera del hero - cambiar fondo
                navbar.classList.remove('bg-transparent');
                navbar.classList.add('bg-neutral-900');
            }
        },
        {
            root: null,
            threshold: 0,
            rootMargin: "-100px 0px 0px 0px" // Ajusta para activar un poco antes de salir del hero
        }
    );

    observer.observe(heroSection);

    const buttons = document.querySelectorAll('.list-buttons .btn-tag');
    const cards = document.querySelectorAll('.card-post');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            // Marcar botón activo
            buttons.forEach(btn => btn.classList.remove('btn-tag-active'));
            button.classList.add('btn-tag-active');

            const tagId = button.id;

            cards.forEach(card => {
                const cardTag = card.dataset.tag;

                if (tagId === 'todos' || tagId === cardTag) {
                    card.parentElement.style.display = 'block'; // el <a> es el padre
                } else {
                    card.parentElement.style.display = 'none';
                }
            });
        });
    });

});
